module.exports = __webpack_public_path__ + "img/fatherhood_5.71f4d218.jpg";